import { useThemeStore } from '../../app/themeStore.js';
import { useUnitsStore } from '../../app/unitsStore.js';
import { useTextScaleStore } from '../../app/textScaleStore.js';
import { useTrailStore } from '../nav/trailStore.js';
import { usePredictorStore } from '../nav/predictorStore.js';
import { Segmented } from '../../lib/Segmented.js';
import { msg } from '../../lib/messages.js';

/** KART (theme) + VISNING + ENHETER (units) settings sections (spec 07). */
export function PrefsSection(): JSX.Element {
  const mode = useThemeStore((s) => s.mode);
  const setMode = useThemeStore((s) => s.setMode);
  const textScale = useTextScaleStore((s) => s.scale);
  const setTextScale = useTextScaleStore((s) => s.setScale);
  const trailMode = useTrailStore((s) => s.mode);
  const setTrailMode = useTrailStore((s) => s.setMode);
  const predictorMode = usePredictorStore((s) => s.mode);
  const setPredictorMode = usePredictorStore((s) => s.setMode);
  const units = useUnitsStore();

  return (
    <>
      <section className="settings__section">
        <h2 className="settings__section-title">{msg.settings.mapSection}</h2>
        <div className="settings-row">
          <span className="settings-row__label">{msg.settings.theme}</span>
          <Segmented
            ariaLabel={msg.settings.theme}
            value={mode}
            onChange={setMode}
            options={[
              { value: 'auto', label: msg.settings.themeAuto },
              { value: 'day', label: msg.settings.themeDay },
              { value: 'night', label: msg.settings.themeNight },
            ]}
          />
        </div>
        <div className="settings-row">
          <span className="settings-row__label">{msg.settings.trail}</span>
          <Segmented
            ariaLabel={msg.settings.trail}
            value={trailMode}
            onChange={setTrailMode}
            options={[
              { value: 'off', label: msg.settings.trailOff },
              { value: 'short', label: msg.settings.trailShort },
              { value: 'medium', label: msg.settings.trailMedium },
              { value: 'long', label: msg.settings.trailLong },
            ]}
          />
        </div>
        <div className="settings-row">
          <span className="settings-row__label">{msg.settings.predictor}</span>
          <Segmented
            ariaLabel={msg.settings.predictor}
            value={predictorMode}
            onChange={setPredictorMode}
            options={[
              { value: 'off', label: msg.settings.predictorOff },
              { value: 'm1', label: msg.settings.predictor1 },
              { value: 'm3', label: msg.settings.predictor3 },
              { value: 'm6', label: msg.settings.predictor6 },
            ]}
          />
        </div>
      </section>

      <section className="settings__section">
        <h2 className="settings__section-title">{msg.settings.displaySection}</h2>
        <div className="settings-row">
          <span className="settings-row__label">{msg.settings.textSize}</span>
          <Segmented
            ariaLabel={msg.settings.textSize}
            value={textScale}
            onChange={setTextScale}
            options={[
              { value: 'small', label: msg.settings.textSmall },
              { value: 'normal', label: msg.settings.textNormal },
              { value: 'large', label: msg.settings.textLarge },
              { value: 'xlarge', label: msg.settings.textXLarge },
            ]}
          />
        </div>
      </section>

      <section className="settings__section">
        <h2 className="settings__section-title">{msg.settings.unitsSection}</h2>
        <div className="settings-row">
          <span className="settings-row__label">{msg.settings.unitSpeed}</span>
          <Segmented
            ariaLabel={msg.settings.unitSpeed}
            value={units.speed}
            onChange={(speed) => units.set({ speed })}
            options={[
              { value: 'kn', label: 'kn' },
              { value: 'kmh', label: 'km/t' },
            ]}
          />
        </div>
        <div className="settings-row">
          <span className="settings-row__label">{msg.settings.unitDistance}</span>
          <Segmented
            ariaLabel={msg.settings.unitDistance}
            value={units.distance}
            onChange={(distance) => units.set({ distance })}
            options={[
              { value: 'nm', label: 'nm' },
              { value: 'km', label: 'km' },
            ]}
          />
        </div>
        <div className="settings-row">
          <span className="settings-row__label">{msg.settings.unitConsumption}</span>
          <Segmented
            ariaLabel={msg.settings.unitConsumption}
            value={units.consumption}
            onChange={(consumption) => units.set({ consumption })}
            options={[
              { value: 'l_per_nm', label: 'l/nm' },
              { value: 'l_per_h', label: 'l/t' },
            ]}
          />
        </div>
        <div className="settings-row">
          <span className="settings-row__label">{msg.settings.unitCourse}</span>
          <Segmented
            ariaLabel={msg.settings.unitCourse}
            value={units.courseRef}
            onChange={(courseRef) => units.set({ courseRef })}
            options={[
              { value: 'true', label: msg.settings.courseTrue },
              { value: 'magnetic', label: msg.settings.courseMagnetic },
            ]}
          />
        </div>
      </section>
    </>
  );
}
